const normalizeCompanyIds = companyIds =>
  (Array.isArray(companyIds) ? companyIds : [companyIds])
    .flat()
    .map(companyId => Number(companyId))
    .filter(
      (companyId, index, normalizedCompanyIds) =>
        Number.isInteger(companyId) &&
        companyId > 0 &&
        normalizedCompanyIds.indexOf(companyId) === index,
    );

const getInvoiceCompanyIds = ({ companyId, crossInvoiceCompanyIds = [] }) =>
  normalizeCompanyIds([companyId, crossInvoiceCompanyIds]);

const getCrossInvoiceCompanyOptions = ({ companies = [], currentCompanyId }) =>
  companies
    .filter(company => Number(company?.id) !== Number(currentCompanyId))
    .map(company => ({
      label: company?.name,
      value: Number(company?.id),
    }));

const getSelectedCompanyOptions = ({ companyIds = [], options = [] }) => {
  const normalizedCompanyIds = normalizeCompanyIds(companyIds);
  return options.filter(option =>
    normalizedCompanyIds.includes(Number(option?.value)),
  );
};

const getCompanyIdsFromOptions = options =>
  normalizeCompanyIds(options?.map(option => option?.value) || []);

const haveSameCompanyIds = (firstCompanyIds, secondCompanyIds) => {
  const firstNormalizedCompanyIds = normalizeCompanyIds(firstCompanyIds);
  const secondNormalizedCompanyIds = normalizeCompanyIds(secondCompanyIds);

  return (
    firstNormalizedCompanyIds.length === secondNormalizedCompanyIds.length &&
    firstNormalizedCompanyIds.every(companyId =>
      secondNormalizedCompanyIds.includes(companyId),
    )
  );
};

export {
  getCompanyIdsFromOptions,
  getCrossInvoiceCompanyOptions,
  getInvoiceCompanyIds,
  getSelectedCompanyOptions,
  haveSameCompanyIds,
  normalizeCompanyIds,
};
